import React from "react";
import SocialCard from "./SocialCard";

const SocialSection = ({ details }) => {
  return (
    <section className="container social-section">
      <SocialCard details={details} />
    </section>
  );
};

export default SocialSection;
